import { noMeetingResponseRequired } from './MeetingRequestNoResponseButton.locstring.json';
import loc from 'owa-localize';
import MeetingActionButton from './MeetingActionButton';
import deleteMeetingMessage from '../actions/deleteMeetingMessage';
import { default as logMeetingMessageAction } from '../utils/logMeetingMessageAction';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

import * as React from 'react';

export interface MeetingRequestNoResponseButtonProperties {
    item: MeetingRequestMessageType;
    entrySource: MeetingMessageActionEntrySource;
}

export default observer(function MeetingRequestNoResponseButton(
    props: MeetingRequestNoResponseButtonProperties
) {
    const onClick = React.useCallback(() => {
        logMeetingMessageAction('NoResponseClicked', props.item, props.entrySource);
        deleteMeetingMessage(props.item, true);
    }, [props.item]);

    return (
        <MeetingActionButton
            text={loc(noMeetingResponseRequired)}
            onClick={onClick}
            iconProps={{ iconName: ControlIcons.EventInfo }}
            secondary={true}
        />
    );
});
